import React from 'react';
import {SignatureDateInputElement} from 'types/documentTemplateElement';
import {DocumentTemplate} from '../../../types/documentTemplate';
import BaseInputProperties from './BaseInputProperties';
import RadioInputHorizontal from '../../inputs/RadioInputHorizontal';
import TextInput from '../../inputs/TextInput';

interface SignatureDateInputPropertiesProps {
  element: SignatureDateInputElement;
  template: DocumentTemplate;
  updateElement: (updatedElement: SignatureDateInputElement) => void;
}

const SignatureDateInputProperties: React.FC<
  SignatureDateInputPropertiesProps
> = ({element, template, updateElement}) => {
  const customLabels = {
    adminOnly: 'Admin signature required',
  }

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const {id, value} = e.target;
    updateElement({
      ...element,
      properties: {
        ...element.properties,
        [id]: value,
      },
    });
  };

  const additionalFields = (
    <>
      <RadioInputHorizontal
        label="Show subtext"
        options={[
          {id: 'show-signature-date-subtext-yes', label: 'Yes', value: true},
          {id: 'show-signature-date-subtext-no', label: 'No', value: false},
        ]}
        selectedValue={element.properties.showSubText}
        onChange={value =>
          updateElement({
            ...element,
            properties: {...element.properties, showSubText: value},
          })
        }
      />
      {element.properties.showSubText && (
        <TextInput
          id="subText"
          type="input"
          label=""
          value={element.properties.subText || ''}
          onChange={handleChange}
        />
      )}
      <RadioInputHorizontal
        label="Show date label"
        options={[
          {id: 'show-date-label-yes', label: 'Yes', value: true},
          {id: 'show-date-label-no', label: 'No', value: false},
        ]}
        selectedValue={element.properties.showLabelDate}
        onChange={value =>
          updateElement({
            ...element,
            properties: {...element.properties, showLabelDate: value},
          })
        }
      />
      {element.properties.showLabelDate && (
        <TextInput
          id="dateLabel"
          type="input"
          label=""
          value={element.properties.dateLabel || ''}
          onChange={handleChange}
        />
      )}

      <RadioInputHorizontal
        label="Allow Past Dates"
        options={[
          {id: 'allow-past-dates-yes', label: 'Yes', value: true},
          {id: 'allow-past-dates-no', label: 'No', value: false},
        ]}
        selectedValue={element.properties.allowPastDates}
        onChange={value =>
          updateElement({
            ...element,
            properties: {...element.properties, allowPastDates: value},
          })
        }
      />
    </>
  );

  return (
    <BaseInputProperties
      element={element}
      template={template}
      updateElement={updateElement}
      additionalFields={additionalFields}
      hidePlaceholder={true}
      hideFillOutOnCreation={true}
      customLabels={customLabels}
    />
  );
};

export default SignatureDateInputProperties;
